import React from 'react';
// MUI
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {Box, Container, Typography} from '@material-ui/core/';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    footer: {
      padding: theme.spacing(2),
      marginTop: theme.spacing(4),
      color: 'white',
      backgroundColor: '#58595b',
      boxShadow: '0 50vh 0 50vh #58595b', // extends color to bottom of page
      textAlign: 'right'
    }
  })
);

export type HdaeFooterProps = {
  maxWidth: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

const HdaeFooter: React.FC<HdaeFooterProps> = props => {
  const classes = useStyles();

  return (
    <Box
      component="footer"
      className={classes.footer}
      displayPrint="none"
    >
      <Container maxWidth={props.maxWidth}>
        <Typography variant="body2">&copy; Regents of the University of California</Typography>
      </Container>
    </Box>
  );
}

export default HdaeFooter;
